import React from 'react'
import { Link } from "react-router-dom";
import "./Navbar.css";
import Home from './Home';
import Contactme from './Contactme';
import Projects from './Projects';
export default function Navbar() {
    return (
        <div>
            <ul className='Navbar'>
                <li className='Navbar-item'>
                    <Link to='/' className='Navbar-link'>Home</Link>
                </li>
                <li className='Navbar-item'>
                    <Link to='/projects' className='Navbar-link'>Projects</Link>
                </li>
                <li className='Navbar-item'>
                    <Link to='/contact' className='Navbar-link'>Contact Me</Link>
                </li>

            </ul>






        </div>
    )
}
